module.exports = __webpack_public_path__ + "media/images/emblems/Uttwil-Blazono-3286d58596caa8684950469c82ef2f72.png";